import React from "react";
import '../Styles/Navbar.scss';
import Navigation from "./Navigation";
import MobileNavigation from "./MobileNavigation";

function Navbar() {
   return (
      <div>

         <div className ='regularNav'>
            <Navigation />
         </div>

         <div className="mobileNavigation">
            <MobileNavigation/>
         </div>

      </div>
   );
}

export default Navbar;